import { Component, OnDestroy } from '@angular/core';
import { COMPONENT_TAG_HISTORY_TABLE_MODEL } from './component-tag-history-table.model';
import {
  AppNotificationUtilClass,
  AssemblyInCommonService,
  BarcodeScannerService,
  BleService,
  HIDService,
  ScannerDataFormatter,
  ZebraBleModeReaderService,
} from '@monorepo/services';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CpiHelper } from '@monorepo/utils';

@Component({
  selector: 'monorepo-component-tag-history',
  templateUrl: './component-tag-history.component.html',
  styleUrls: ['./component-tag-history.component.css'],
})
export class ComponentTagHistoryComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  constructor(
    private assemblyService: AssemblyInCommonService,
    private appbotificationutil: AppNotificationUtilClass,
    private modalController: ModalController,
    private scannerDataFormatter: ScannerDataFormatter,
    private translate: TranslateService,
    private bleService: BleService,
    private hidService: HIDService,
    private barcodeScannerService: BarcodeScannerService,
    private zebraBleModeService: ZebraBleModeReaderService
  ) {
    const s1 = this.bleService.getScannedInfoEmitterSubscription().subscribe((res) => {
      if (res.lockDetails.isLocked && res.lockDetails.source === 'SEARCH_TAG_HISTORY')
        this.handleScannedTag(res.byteString);
    });
    const s2 = this.hidService.getScannedInfoEmitterSubscription().subscribe((res) => {
      if (res.lockDetails.isLocked && res.lockDetails.source === 'SEARCH_TAG_HISTORY')
        this.handleScannedTag(res.byteString);
    });
    const s3 = this.zebraBleModeService.getZebraBleScannedDataSubscription().subscribe((res) => {
      if (res.lockDetails.isLocked && res.lockDetails.source === 'SEARCH_TAG_HISTORY')
        this.handleScannedTag(res.byteString);
    });

    this.subscriptions.push(s1, s2, s3);
  }

  tableModel = COMPONENT_TAG_HISTORY_TABLE_MODEL.createTableModel([]);
  componentTag = '';

  async getcomponentTagHistory(componentTag: string) {
    if (componentTag) {
      const tagType = CpiHelper.getTagType(componentTag[0]);
      if (tagType !== 'COMPONENT_BUNDLE') {
        await this.appbotificationutil.showPopup(
          this.translate.instant('common.error'),
          this.translate.instant('component_tag_history.please_scan_component_tag'),
        );
        return;
      }
      const loader = await this.appbotificationutil.presentLoading();
      this.assemblyService
        .getComponentTagProcessHistory(componentTag)
        .subscribe((res) => {
          if (res.status === 'SUCCESS') {
            this.tableModel = COMPONENT_TAG_HISTORY_TABLE_MODEL.createTableModel(res.history || []);
          } else {
            this.appbotificationutil.showPopup(
              this.translate.instant('common.error'),
              res.error || this.translate.instant('common.somethingWentWrong'),
            );
            this.tableModel = COMPONENT_TAG_HISTORY_TABLE_MODEL.createTableModel([]);
          }
        })
        .add(() => {
          this.componentTag = '';
          this.appbotificationutil.dismissLoadingV2(loader);
        });
    }
  }

  close() {
    this.modalController.dismiss();
  }

  private async handleScannedTag(scanText: string): Promise<void> {
    console.log('[SCAN TEXT]', scanText);
    const formattedTagData = this.scannerDataFormatter.decodeTagString(scanText);
    console.log('[FORMATTED TAG DATA]', formattedTagData);
    if (formattedTagData.status && formattedTagData.data['did']) {
      await this.getcomponentTagHistory(formattedTagData.data['did'] as string);
    } else {
      await this.appbotificationutil.showPopup(
        this.translate.instant('common.error'),
        formattedTagData.error || this.translate.instant('common.scanError'),
      );
    }
  }

  async scanTag(): Promise<void> {
    const scanResponse = await this.barcodeScannerService.openBarcodeScanner<string>();

    if (scanResponse.type === 'SUCCESS_STRING') {
      await this.handleScannedTag(scanResponse.scanText);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
